export class ICrud {
    constructor() {
    }

    async query() {
        throw "Not Implemented";
    }

    async getAll() {
        throw "Not Implemented";
    }

    async getByID() {
        throw "Not Implemented";
    }

    async create() {
        throw "Not Implemented";
    }

    async modify() {
        throw "Not Implemented";
    }

    async delete() {
        throw "Not Implemented";
    }
}